import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Data, Wellcome } from '../../Interfaces/produtos';
import { Observable, of, tap } from 'rxjs';
import { CacheService } from '../Cache/cache.service';
import { FormPaymentLocal, OrderLocal, OrderUser } from 'src/app/shared/Interfaces/pedido';
import { Authentication } from 'src/app/guard/verification/verification.guard';
import { event } from '../events/events.service';
import { AllOrders, SingleOrder } from 'src/app/shared/Interfaces/order';
import { environment } from 'src/environments/environment';
import { Address, Cliente, Usuario } from 'src/app/shared/Interfaces/customer';
import { Company } from '../Connection/connection.service';
@Injectable({
  providedIn: 'root'
})

export class ApiService {

  urlAPI = environment.apiUrl;
  urlWebHook = environment.webHookUrl;
  company!: Company

  constructor(private httpClient: HttpClient, private cacheService: CacheService) { }

  //#region Requisições GET

  //GET - Verifica promoção para caso o usuário selecione um pagamento no pix. (Borda Pix - Deprecated)
  promotionPaymentForm(order: any): Observable<any> {
    const url = `${this.urlAPI}/orders/promotionalproduct/verify`
    const body = order

    return this.httpClient.post<any>(url, body)
  }

  //GET - Resgata o histórico de cashback
  historyCashback(id_customer: string, id_company: string): Observable<any> {
    const url = `${this.urlAPI}/customer/historyCashback/${id_customer}/${id_company}`;

    return this.httpClient.get(url);
  }

  //GET - Verifica se o pagamento pix foi confirmado ou expirado.
  confirmationPix(id_order: string, id_company: string): Observable<any> {
    const url = `${this.urlAPI}/pix/payment/${id_order}/${id_company}`

    return this.httpClient.get(url);
  }

  //GET - Inicia a verificação do pagamento no (SERVIDOR / WEBSOCKET)
  startVerification(id_order: string, id_company: string): Observable<any> {
    const url = `${this.urlWebHook}/payment/startVerification/${id_order}/${id_company}`;

    return this.httpClient.get(url);
  }

  //GET - Resgata o status do pedido.
  getStatusOrder(id_order: string): Observable<any> {
    const url = `${this.urlAPI}/orders/getStatusOrder/${id_order}`;

    return this.httpClient.get(url);
  }

  //GET - Resgata o endereço do cliente pelo cep
  getCepApi(cep: number): Observable<any> {

    const url = `https://h-apigateway.conectagov.estaleiro.serpro.gov.br/api-cep/v1/consulta/cep/${cep}`;

    return this.httpClient.get(url, { headers: { 'x-cpf-usuario': '12363288920' } });
  }

  //GET - Recebe o valor e a distancia da rota do estabelecimento até o cliente
  deliveryPrice(id_company: string, origin: string, destination: string, id_Address: string, valueOrder: number): Observable<any> {

    const encodedOrigin = encodeURIComponent(origin);
    const encodedDestination = encodeURIComponent(destination);

    const url = `${this.urlAPI}/distances/route/${id_company}/${encodedOrigin}/${encodedDestination}/${id_Address}/${valueOrder}`;
    // const url = `http://192.168.100.29:4201/distances/route/${id_company}/${encodedOrigin}/${encodedDestination}/${id_Address}`;

    return this.httpClient.get<any>(url)
  }

  //GET - Resgata as informações do estabelecimento
  getCompany(name_Company: string): Observable<any> {

    const nameCompanyFormated = encodeURIComponent(name_Company);

    let url = (`${this.urlAPI}/company/${nameCompanyFormated}`);

    return this.httpClient.get<any>(url);
  }

  //GET - Verifica se o numero do QrCode é valido
  getAuthentication(number: string, nameCompany: string): Observable<Authentication> {

    // let url = (`http://192.168.100.29:4201/tables/id/${number}/${nameCompany}`)
    let url = (`${this.urlAPI}/tables/id/${number}/${nameCompany}`);

    return this.httpClient.get<Authentication>(url);

  }

  //Resgata um unico pedido pelo seu ID
  getSingleOrder(id_order: number) {
    let url = (`${this.urlAPI}/orders/${id_order}`);

    return this.httpClient.get<SingleOrder>(url);
  }

  //GET - Resgata todos os pedidos do usuário
  getOrdersUser(id: string, id_empresa: string, quantity: number): Observable<AllOrders> {

    let url = '';
    url = (`${this.urlAPI}/orders/customer/${id}/${id_empresa}/${quantity}`);

    return this.httpClient.get<AllOrders>(url);
  }

  //Resgata o pedido que esta em consumo na mesa ou comanda
  getOrderConsumption(card: number, table: number, id_empresa: string): Observable<SingleOrder> {
    let url = '';

    if (card != 0) {
      url = (`${this.urlAPI}/orders/localOrders/card/${card}/table/0/company/${id_empresa}`);
    }
    else {
      url = (`${this.urlAPI}/orders/localOrders/card/${card}/table/${table}/company/${id_empresa}`);
    }


    return this.httpClient.get<SingleOrder>(url);
  }

  //GET - Resgata as informações do usuario pelo seu numero de telefone
  getUsuario(phoneNumber: string, id_company: string): Observable<Usuario> {
    const url = (`${this.urlAPI}/customer/${phoneNumber}?id_company=${id_company}`);
    //const url = (`${this.urlAPI}/customer/${phoneNumber}`);

    return this.httpClient.get<Usuario>(url);
  }

  //GET - Resgata um produto especifico pelo de ID
  getProduto(id: number, typeParam: number): Observable<Data> {
    let headers;
    if (typeParam == 1 || typeParam == 2) {
      headers = new HttpHeaders().set('type', '1')
    }
    else {
      headers = new HttpHeaders().set('type', '2')
    }
    return this.httpClient.get<Data>(`${this.urlAPI}/products/additional/${id}`, { headers });
  }

  //GET - Resgata todas as categorias e produtos do estabelecimento
  getTabela(): Observable<Wellcome> {
    const cacheData = this.cacheService.getItemSession('tabela_cache_key');

    if (cacheData) {
      return of(cacheData);
    }
    else {

      return this.httpClient.get<Wellcome>(`${this.urlAPI}/products/company`).pipe(
        tap(data => this.cacheService.setItemSession('tabela_cache_key', data))
      );
    }
  }

  //GET - Resgata as horas do servidor
  getHours(): Observable<any> {

    const url = `${this.urlAPI}/company/get/HourServer`;

    return this.httpClient.get<any>(url);

  }

  //GET - Resgata as observações cadastradas na loja.
  getObservation(id_company: string): Observable<any> {

    const url = `${this.urlAPI}/company/observations/${id_company}`;

    return this.httpClient.get<any>(url);
  }

  //GET - Status da loja Fechada/Aberta
  verifiStatusCompany(id_company: string): Observable<any> {
    const url = `${this.urlAPI}/teste/getTeste/${id_company}`;
    return this.httpClient.get<any>(url);
  }

  //GET - Resgata se o cliente e a loja tem fidelidades ativas
  getFidelity(id_customer: string, id_company: string): Observable<any> {

    const url = `${this.urlAPI}/customer/fidelity/${id_customer}/${id_company}`;

    return this.httpClient.get<any>(url);
  }

  //GET - Resgata o status do checkout
  getStatusCheckout(sessionId: string): Observable<any> {
    const url = `${this.urlAPI}/checkout/status-checkout/${sessionId}`

    return this.httpClient.get<any>(url);
  }

  //GET - Resgata o checkout Reembolso
  getCheckoutRefund(sessionId: string): Observable<any> {
    const url = `${this.urlAPI}/checkout/refund/${sessionId}`

    return this.httpClient.get<any>(url);
  }

  //GET - Bairros cadastrados no estabelecimento
  getNeighborhood(id_company: string): Observable<any> {
    const url = `${this.urlAPI}/distances/neighborhood/get/${id_company}`

    return this.httpClient.get<any>(url);
  }

  //GET - Cidades do estado selecionado.
  getCitysForState(state: string): Observable<any> {
    const url = `${this.urlAPI}/company/cities/state/${state}`;

    return this.httpClient.get<any>(url)
  }

  //GET - Localizações nos modos balcão
  getPlacesCounter(id_place: string): Observable<any> {
    const url = `${this.urlAPI}/company/places/${id_place}`;

    return this.httpClient.get(url);
  }

  //GET - Valida se os intens foram integrados.
  getIntegration(ids_itens: any[], id_company: string): Observable<any> {
    const url = `${this.urlAPI}/orders/integrated/item/${id_company}`

    const headers = new HttpHeaders({
      'ids-itens': `${ids_itens}`
    });
    return this.httpClient.get(url, { headers });
  }


  //#endregion

  //#region Requisições POST

  //POST - Envia a solicitação de pagamento e gera o link de checkout MERCADO PAGO
  postCallCheckoutMP(body: any): Observable<any> {
    const url = `${this.urlAPI}/mp/checkout`;
    return this.httpClient.post(url, body);
  }

  //POST - Envia a solicitação de pagamento e gera o link de checkout STRIPE
  postCreateCheckout(orderId: string, descricao: string, id_company: string): Observable<any> {
    const url = `${this.urlAPI}/checkout/create-checkout`

    const body = {
      orderId: orderId,
      descricao: descricao,
      id_company: id_company
    }

    return this.httpClient.post<any>(url, body)
  }

  //POST - Faz o link de criação de conta
  postAccount(email: string): Observable<any> {
    const url = `${this.urlAPI}/checkout/account`

    const body = {
      email: email
    }

    return this.httpClient.post<any>(url, body)
  }

  //POST - Envia o pix com as informações de pagamento
  paymentPix(order: any) {
    // const url = `${this.urlAPI}/pix/QrCode`;

    // const body = {
    //   referenciaExterna: order.id_order,
    //   valor: order.orderPrice,
    //   mensagemPagador: "Pedeaqui.app",
    //   expiracao: 500,
    //   id_company: order.id_company
    // }

    // return this.httpClient.post<any>(url, body);


    const url = `${this.urlAPI}/fiserv/gerar/qrcode`;

    const body = {
      referenciaExterna: order.id_order,
      id_company: order.id_company
    }

    return this.httpClient.post<any>(url, body);
  }

  //POST - Verifica se o cupom existe e se é valido
  VerifiCoupon(cupom: string, id_company: string, day: number, productsOrder: any, id_customer: string): Observable<any> {
    const url = `${this.urlAPI}/orders/getCoupons/${id_company}/${day}/${cupom}/${id_customer}`;

    const body = {
      products: productsOrder
    }

    return this.httpClient.post<any>(url, body);
  }

  //POST - Registra o endereço do usuario
  postAddress(id_customer: string, address: Address): Observable<any> {

    const url = `${this.urlAPI}/customer/address`;

    return this.httpClient.post<any>(url, { id_customer, address });
  }

  //POST - Envia um evento para API
  events(event: event): Observable<any> {

    let url = (`${this.urlAPI}/orders/new/events`);

    return this.httpClient.post<event>(url, event);
  }

  //POST - Responsavel por enviar o pedido para API
  FazerPedido(Pedido: OrderUser): Observable<any> {
    let url = '';
    url = (`${this.urlAPI}/orders`);

    return this.httpClient.post<any>(url, Pedido);
  }

  //POST - Responsavel por enviar o pedido para API só que pedido em Mesa
  MakeOrderLocal(Pedido: OrderLocal): Observable<any> {
    let url = (`${this.urlAPI}/orders/localOrder`);

    return this.httpClient.post<any>(url, Pedido);
  }

  //POST - Altera o pedido quando o usuario adiciona mais um produto ao seu consumo na mesa ou comanda
  AlterarPedido(Pedido: OrderUser): Observable<any> {

    let url = `${this.urlAPI}/orders/items`;

    return this.httpClient.post<any>(url, Pedido);
  }

  //POST - Registra o usuario na base
  postUsuario(user: Cliente): Observable<Usuario> {
    const url = (`${this.urlAPI}/customer`);

    const usuario = user;

    return this.httpClient.post<any>(url, usuario);
  }

  //POST - Resgata o cupom de fidelidade.
  requestCoupon(id_customer: string, id_company: string): Observable<any> {
    const url = (`${this.urlAPI}/customer/fidelityCoupon/${id_customer}/${id_company}`);

    return this.httpClient.post<any>(url, {});
  }

  //POST - Solicita a exclusão da conta do usuário
  requestAccountDeletion(id_customer: string): Observable<any> {
    const url = `${this.urlAPI}/customer/delete-request/${id_customer}`;
    return this.httpClient.post<any>(url, {});
  }

  //#endregion

  //#region Requisições PATCH

  //PATCH - Altera o status do pedido
  alterationStatusOrder(id_order: string, id_company: string, status: number): Observable<any> {
    const url = `${this.urlAPI}/orders/orderNew/${id_order}/${id_company}/${status}`;
    return this.httpClient.patch(url, {});
  }

  //PATCH - Cancela o pedido Delivery
  cancelOrder(id_order: number, id_company: string): Observable<any> {
    const url = `${this.urlAPI}/orders/cancel/admin/${id_order}/${id_company}`;
    return this.httpClient.patch(url, {});
  }

  //PATCH - Cancela item
  cancelItem(id_item: number): Observable<any> {
    const url = `${this.urlAPI}/orders/cancel/${id_item}`;
    return this.httpClient.patch(url, {});
  }

  //PATCH - Altera o nome de usuário
  alterationNameCustomer(id_order: number, newName: string, id_company: string): Observable<any> {
    const url = `${this.urlAPI}/orders/customerName/${id_order}/${newName}/${id_company}`;

    return this.httpClient.patch<any>(url, {});
  }

  //PATCH - Editar o endereço do usuario
  pathAddress(id_customer: string, address: Address): Observable<any> {
    const url = `${this.urlAPI}/customer/address`;

    return this.httpClient.patch<any>(url, { id_customer, address });
  }

  //PATCH - Edita as informações do usuario
  patchUser(id_customer: string, name: string, phone: string, birthDate: string): Observable<any> {
    let url = `${this.urlAPI}/customer`;

    return this.httpClient.patch<any>(url, { id_customer, name, phone, birthDate });
  }

  //PATCH - Altera o numero da mesa/comanda
  pathAlterarionTableNumber(idOrder: number, tableNumber: string, id_empresa: string): Observable<any> {
    let url = (`${this.urlAPI}/orders/tableNumber`);

    const alteration = {
      id_order: idOrder,
      tableNumber: tableNumber,
      id_company: id_empresa
    }

    return this.httpClient.patch<any>(url, alteration);
  }

  //PATCH - Solicita a conta na mesa/comanda
  pathRequestBill(idOrder: number, formPayment: FormPaymentLocal): Observable<FormPaymentLocal> {
    let url = (`${this.urlAPI}/orders/payment/info/${idOrder}`);

    return this.httpClient.patch<FormPaymentLocal>(url, formPayment);

  }

  //PATCH - Exclui o endereço do usuario
  deleteAddress(id_customer: string, id_address: string): Observable<any> {
    const url = `${this.urlAPI}/customer/delete/${id_address}/${id_customer}`;

    return this.httpClient.patch<any>(url, {});
  }

  //#endregion
}
